<div id="page" [ngClass]="{
    'page-platform-mobile' : platform.IOS || platform.ANDROID,
    'page-platform': !(platform.IOS || platform.ANDROID),
    'page-with-header': !isHideHeader,
    'page-without-header': isHideHeader
}" class="page">
    <div class="page-inner">
        <app-header *ngIf="!isHideHeader"></app-header>
        <div class="page-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
